function adjustLoopedItems (slider, items) {
  const newFrontItems = []
  const newRearItems = []
  const cloneCount = slider && slider.getInfo().cloneCount

  if (items && cloneCount) {
    const itemsLength = items.length
    const slideItems = slider.getInfo().slideItems

    for (let i = 0; i < cloneCount; i++) {
      // remove cloned DOM nodes by tiny-slider at the beginning and at the end
      slideItems[0].remove()
      slideItems[slideItems.length - 1].remove()

      // cloneCount can be greater then itemsLength and it should wrap around to give proper continuity
      const index = i % itemsLength

      // Items at the beginning should appear after last product for proper continuity
      newRearItems.push(items[index])
      newFrontItems.push(items[itemsLength - index - 1])
    }
  }

  // Items at the end in reverse order should appear before first product for proper continuity
  return [newFrontItems.reverse(), newRearItems]
}

export {
  adjustLoopedItems
}
